import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { WebsiteAuditService } from '../website-audit.service';

const ALL_TABS: { key: string; label: string }[] = [
  { key: 'seo', label: 'SEO' },
  { key: 'geo', label: 'GEO' },
  { key: 'agenticEcommerce', label: 'AI Shopping Readiness' },
];

@Component({
  selector: 'app-discoverability',
  templateUrl: './discoverability.component.html',
  styleUrls: [
    '../audit-theme.css',
    '../experience/experience.component.css',
    './discoverability.component.css',
  ],
})
export class DiscoverabilityComponent implements OnInit, OnDestroy {
  constructor(private websiteAuditService: WebsiteAuditService) {}

  private subs = new Subscription();

  public selectedTab: string = 'seo';
  public tabs: { key: string; label: string }[] = [...ALL_TABS];

  ngOnInit(): void {
    this.subs.add(
      this.websiteAuditService.getSelectedAuditTask().subscribe((task: any) => {
        // A Crawler audit is crawl-only: no organic crawl backs SEO/GEO, so AI
        // Shopping Readiness is the only chip that has anything to show.
        const isCrawler = task?.type === 'Crawler';
        this.tabs = isCrawler
          ? ALL_TABS.filter((t) => t.key === 'agenticEcommerce')
          : [...ALL_TABS];

        if (!this.tabs.some((t) => t.key === this.selectedTab)) {
          this.selectedTab = this.tabs[0]?.key || 'seo';
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
